import { render, staticRenderFns } from "./RcpyN_Details_Rec.vue?vue&type=template&id=244ef425"
import script from "./RcpyN_Details_Rec.vue?vue&type=script&lang=js"
export * from "./RcpyN_Details_Rec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports